/**
 * Type guard to check if a value is a number.
 *
 * @param {unknown} value - The value to check.
 * @returns {boolean} True if the value is a number, false otherwise.
 *
 * @example
 * if (isNumber(someValue)) {
 *   // someValue is typed as number here
 *   console.log(someValue.toFixed(2));
 * }
 */
export const isNumber = (value: unknown): value is number => {
    return typeof value === 'number';
};
